export { default as CheckoutOrderSummarySkeleton } from "./CheckoutOrderSummarySkeleton";
